import classnames from 'classnames';

import UserAvatar from 'components/userAvatar';
import { importStatic } from 'utils';

import { HeaderIcon } from '../icon';

import classes from './index.module.css';

const Link = ({ href, title }) => (
  <li>
    <a className="d-flex align-items-center" href={href}>
      {title}
    </a>
  </li>
);

export const Avatar = ({
  setWrapperRef,
  avatar,
  desktopDevice,
  isCompanyUser,
  goToMatches,
  handleLogout,
  toggleMobileMenu,
  toggleProfileMenu,
  profileMenu,
}) => (
  <div className={classes.container}>
    <div className="d-none d-lg-block" ref={setWrapperRef}>
      <div onClick={toggleProfileMenu} aria-expanded={profileMenu} aria-controls="loginInfoArea">
        <UserAvatar
          src={avatar || importStatic('/ui-router/images/default-user.png')}
          fallbackSrc={importStatic('/ui-router/images/default-user.png')}
          onError={(e) => {
            e.target.src = importStatic('/ui-router/images/default-user.png');
          }}
          isDesktop={desktopDevice}
        />
      </div>
      <div
        className={classnames(classes.dropdown, {
          [classes.show]: profileMenu,
        })}
        id="loginInfoArea"
      >
        <ul className="m-0 p-0">
          {!isCompanyUser && (
            <li className="d-flex align-items-center" onClick={goToMatches}>
              My Jobs
            </li>
          )}
          <Link href="/my-resume/" title="My Resume" />
          <Link href="/matches/salary/" title="My Salary Report" />
          <Link href="/dashboard/" title="My Career Insights" />
          <div className={classes.divider} />
          <Link href="/profile/" title="Profile" />
          <li className="g_id_signout d-flex align-items-center" onClick={handleLogout}>
            Log Out
          </li>
        </ul>
      </div>
    </div>
    <div className="d-block d-lg-none" onClick={toggleMobileMenu}>
      <UserAvatar
        src={avatar || importStatic('/ui-router/images/default-user.png')}
        fallbackSrc={importStatic('/ui-router/images/default-user.png')}
        isDesktop={desktopDevice}
      />
    </div>
  </div>
);
